import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { MarqueeBanner } from '../MarqueeBanner';
import AppsIcon from '../../assets/images/gwIconApps.svg';
import StorageIcon from '../../assets/images/gwIconStorage.svg';
import EmailIcon from '../../assets/images/gwIconEmail.svg';
import GeminiIcon from '../../assets/images/gwIconGemini.svg';
const KEY_PREFIX = 'domain_search_gate.business_email_results.google_workspace_banner';
export const GoogleWorkspaceBanner = () => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const items = [{
    id: 'apps',
    Icon: AppsIcon,
    text: t(`${KEY_PREFIX}.apps`)
  }, {
    id: 'storage',
    Icon: StorageIcon,
    text: t(`${KEY_PREFIX}.storage`)
  }, {
    id: 'email',
    Icon: EmailIcon,
    text: t(`${KEY_PREFIX}.email`)
  }, {
    id: 'gemini',
    Icon: GeminiIcon,
    text: t(`${KEY_PREFIX}.gemini`)
  }];
  return /*#__PURE__*/React.createElement(MarqueeBanner, {
    items: items,
    dataHook: "google-workspace-banner",
    gap: "6px"
  });
};
//# sourceMappingURL=GoogleWorkspaceBanner.js.map